import type { RadioStation } from '@/mocks/radios';
import { sponsors, type Sponsor } from '@/mocks/sponsors';

interface RadioPatrocinadoresSectionProps {
  station: RadioStation;
}

export default function RadioPatrocinadoresSection({ station }: RadioPatrocinadoresSectionProps) {
  const activeSponsors = sponsors.filter((s) => s.status === 'activo');
  const rfwSponsors = sponsors.filter((s) => s.status === 'activo' && s.type === 'nacional').slice(0, 3);

  return (
    <section className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
      <div className="px-5 py-3 border-b border-background-200/70">
        <h3 className="text-base font-bold text-foreground-950 uppercase tracking-wide">Patrocinadores</h3>
      </div>

      {/* Own Sponsors */}
      <div className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <i className="ri-store-2-line text-sm text-foreground-500"></i>
          <h4 className="text-sm font-semibold text-foreground-700">Patrocinadores de esta radio</h4>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {activeSponsors.slice(0, 4).map((sponsor) => (
            <div key={sponsor.id} className="rounded-lg border border-background-200/70 bg-background-100/50 p-3 flex flex-col items-center text-center hover:border-background-300/60 transition-all cursor-pointer group">
              <div className="w-12 h-12 rounded-lg bg-background-200/70 flex items-center justify-center mb-2 group-hover:scale-105 transition-transform">
                <i className="ri-building-4-line text-xl text-foreground-400"></i>
              </div>
              <p className="text-xs font-semibold text-foreground-950 line-clamp-1">{sponsor.companyName}</p>
              <div className="flex items-center gap-2 mt-1 text-[10px] text-foreground-500">
                <span className="px-1.5 py-0.5 rounded-full bg-background-200/70 capitalize">
                  {sponsor.type}
                </span>
                <span>{sponsor.sector}</span>
              </div>
            </div>
          ))}
        </div>

        {activeSponsors.length > 4 && (
          <button className="mt-3 text-xs font-semibold text-foreground-500 hover:text-foreground-700 cursor-pointer transition-colors flex items-center gap-1 whitespace-nowrap">
            Ver {activeSponsors.length - 4} patrocinadores más <i className="ri-arrow-down-s-line"></i>
          </button>
        )}
      </div>

      {/* RFW Ads */}
      <div className="border-t border-background-200/70 p-4">
        <div className="flex items-center gap-2 mb-3">
          <i className="ri-advertisement-line text-sm text-foreground-500"></i>
          <h4 className="text-sm font-semibold text-foreground-700">RFW Ads</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {rfwSponsors.map((sponsor) => (
            <div key={sponsor.id} className="rounded-lg border border-background-200/70 bg-background-100/50 p-3 flex items-center gap-3 hover:border-background-300/60 transition-all cursor-pointer">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-broadcast-line text-lg text-accent-700"></i>
              </div>
              <div className="min-w-0">
                <p className="text-xs font-semibold text-foreground-950 line-clamp-1">{sponsor.companyName}</p>
                <p className="text-[10px] text-foreground-500">{sponsor.sector} · {sponsor.type}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}